// Module
var code = "<freight-costs></freight-costs>\n";
// Exports
module.exports = code;